import styled from "styled-components";

interface KanbanTitleSectionContainerProps {
  backgroundColor: string;
}

const KanbanSectionTitleContainer = styled.div<KanbanTitleSectionContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px;
  background-color: ${(props) => props.backgroundColor};
  color: white;
  border-radius: 10px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  font-size: 18px;
  width: 100%;
  user-select: none;
  min-height: 80px;
`;

const KanbanSectionTitleContent = styled.div`
  > :first-child {
    fill: white;
    svg {
      width: 22px;
      height: 22px;
    }
    padding-bottom: 5px;
  }
`;

export { KanbanSectionTitleContainer, KanbanSectionTitleContent };
